import React from 'react';
import FacebookPostPreviewMC from './FacebookPostPreviewMC';
import TikTokPostPreviewMC from './TikTokPostPreviewMC';

/**
 * Maps each comment platform to the component that renders its post preview.
 * Adding a new platform is a single entry here, no conditional branching.
 */
const PREVIEW_BY_PLATFORM = {
  facebook_comments: FacebookPostPreviewMC,
  instagram_comments: FacebookPostPreviewMC,
  tik_tok_comments: TikTokPostPreviewMC
};

/**
 * Renders a rich preview of a comment post in the inbox, delegating to the
 * preview component that matches the conversation platform.
 *
 * @component PostPreviewMC
 * @param {Object} props - Component properties
 * @param {Object} props.conversation - The conversation object containing platform and post info.
 * @returns {JSX.Element|null} The platform-specific preview, or null when none applies.
 */
const PostPreviewMC = ({ conversation }) => {
  const PreviewComponent = PREVIEW_BY_PLATFORM[conversation?.platform];

  if (!PreviewComponent) return null;

  return <PreviewComponent conversation={conversation} />;
};

export default PostPreviewMC;
